import * as AddBackorderDemandEvent from '@ori-events/add-backorder-demand';
import * as AddToBasketEvent from '@ori-events/add-to-basket';
import * as AddToBasketFailedEvent from '@ori-events/add-to-basket-failed';
import * as BasketUpdatedEvent from '@ori-events/basket-updated';
import * as LoyaltyDialogResultEvent from '@ori-events/loyalty-dialog-result';
import * as OpenProductInfoDialog from '@ori-events/open-product-info-dialog';
import * as OpenShadePicker from '@ori-events/open-shade-picker';
import { useEffect, useRef, useState } from 'react';
import { QUICK_BUY_BUTTON_STATE_DEFAULT, QUICK_BUY_BUTTON_STATE_ERROR, QUICK_BUY_BUTTON_STATE_LOADING, QUICK_BUY_BUTTON_STATE_SUCCESS, QUICK_BUY_BUTTON_STATE_WAITING } from '../../common';
export const useOnClickEvent = ({
  addToBasketMethod,
  currentPrice,
  currentProductCode,
  lineNumber,
  name,
  placement,
  originalItemCode,
  position,
  hasAutoSubscription,
  isMultiShade
}) => {
  const [event, setEvent] = useState();
  useEffect(() => {
    if (hasAutoSubscription) {
      setEvent(new CustomEvent(OpenProductInfoDialog.Name, {
        detail: {
          mode: OpenProductInfoDialog.DialogMode.StandardBuy,
          placement,
          productCodes: [currentProductCode]
        }
      }));
    } else if (isMultiShade) {
      setEvent(new CustomEvent(OpenShadePicker.Name, {
        detail: {
          placement,
          productCode: currentProductCode
        }
      }));
    } else if (lineNumber == null) {
      setEvent(new CustomEvent(AddToBasketEvent.Name, {
        detail: {
          formattedPrice: currentPrice,
          itemCode: currentProductCode,
          localName: name,
          method: addToBasketMethod,
          originalItemCode,
          placement,
          position,
          quantity: 1
        }
      }));
    } else {
      setEvent(new CustomEvent(AddBackorderDemandEvent.Name, {
        detail: {
          formattedPrice: currentPrice,
          itemCode: currentProductCode,
          lineNumber,
          localName: name,
          placement,
          position,
          quantity: 1
        }
      }));
    }
  }, [addToBasketMethod, currentPrice, currentProductCode, hasAutoSubscription, isMultiShade, lineNumber, name, originalItemCode, placement, position]);
  return event;
};
export const useQuickBuyEvents = ({
  currentProductCode,
  setState
}) => {
  const timeoutRef = useRef();
  useEffect(() => {
    const onBasketUpdated = ({
      detail
    }) => {
      if (detail.lastAddedItem?.itemCode === currentProductCode) {
        setState(QUICK_BUY_BUTTON_STATE_SUCCESS);
        timeoutRef.current = setTimeout(() => setState(QUICK_BUY_BUTTON_STATE_DEFAULT), 3000);
      } else {
        setState(QUICK_BUY_BUTTON_STATE_DEFAULT);
      }
    };
    const onAddToBaskedFailed = () => {
      setState(QUICK_BUY_BUTTON_STATE_ERROR);
      timeoutRef.current = setTimeout(() => setState(QUICK_BUY_BUTTON_STATE_DEFAULT), 300);
    };
    const onOtherAddToBasket = ({
      detail
    }) => {
      if (detail.itemCode === currentProductCode) {
        setState(QUICK_BUY_BUTTON_STATE_LOADING);
      } else {
        setState(QUICK_BUY_BUTTON_STATE_WAITING);
      }
    };
    const onLoyaltyDialogClose = ({
      detail
    }) => {
      if (detail.result === LoyaltyDialogResultEvent.LoyaltyDialogResults.CLOSE) {
        setState(QUICK_BUY_BUTTON_STATE_DEFAULT);
      }
    };
    window.addEventListener(AddToBasketEvent.Name, onOtherAddToBasket);
    window.addEventListener(AddToBasketFailedEvent.Name, onAddToBaskedFailed);
    window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
    window.addEventListener(LoyaltyDialogResultEvent.Name, onLoyaltyDialogClose);
    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener(AddToBasketEvent.Name, onOtherAddToBasket);
      window.removeEventListener(AddToBasketFailedEvent.Name, onAddToBaskedFailed);
      window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
      window.removeEventListener(LoyaltyDialogResultEvent.Name, onLoyaltyDialogClose);
    };
  }, [currentProductCode, setState]);
};
//# sourceMappingURL=hooks.js.map